import { ButtonPalette } from './types';

/* Maps button's level and color props to an underlying Chakra variant name
 * Variants are named according to `level-color`, with default color implied
 * e.g. `primary` (implied default), `primary-alternate`, etc. */
export const getButtonVariant = (
  level: string,
  palette: ButtonPalette,
): string => `${level}${palette !== 'default' ? `-${palette}` : ''}`;
